const generalPageLoadingActionTypes = {
  SET_PAGE_LOADING: "SET_PAGE_LOADING",
};

export default generalPageLoadingActionTypes;
